import type { ReactElement } from "react";
import { Link, useSearchParams } from "react-router";

import { tenantIdOf } from "./center-back-link.js";
import { adminCenterUrls } from "./urls.js";

/** 課金の結果の 2 つの画面。 */
export type PaymentTab = "charges" | "payments";

const tabs: readonly { readonly name: PaymentTab; readonly label: string; readonly href: (tenantId: number | null) => string }[] = [
    { name: "charges", label: "PAY.JP の課金（毎月の請求）", href: (tenantId) => adminCenterUrls.charges({ tenantId }) },
    { name: "payments", label: "ポータルが呼んだ記録", href: (tenantId) => adminCenterUrls.payments({ tenantId }) },
];

/**
 * 課金の結果の切り替え（タブの役の 2 つのボタン）。PAY.JP の課金（<c>/AdminCenter/Charges</c>）と
 * ポータルが呼んだ記録（<c>/AdminCenter/Payments</c>）を行き来する。
 * <b>今いる方は押せない目立つボタン</b>（<c>aria-current</c>）。<b>契約 ID で絞っていれば保って移る</b>（ほかの条件は持ち越さない——結果の選択肢が違う）。
 * 契約 ID は URL から読むので、断られた（400）ときも同じ行き先になる。
 */
export function PaymentTabs({ current }: { readonly current: PaymentTab }): ReactElement {
    const [search] = useSearchParams();
    const tenantId = tenantIdOf(search);
    return (
        <nav className="mb-4 flex flex-wrap gap-2" aria-label="課金の結果の切り替え" data-payment-tabs="">
            {tabs.map((tab) => (tab.name === current
                ? <span key={tab.name} className="btn-primary btn-sm" aria-current="page">{tab.label}</span>
                : <Link key={tab.name} to={tab.href(tenantId)} className="btn-secondary btn-sm">{tab.label}</Link>))}
        </nav>
    );
}
